"use client";

import { Eye, MessageSquare, Users, FileText, CircleCheck as CheckCircle2, TrendingUp } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const metrics = [{
  icon: Eye,
  value: "164.9K+",
  label: "Page Views",
  growth: "↑ 100% Increase"
}, {
  icon: MessageSquare,
  value: "498+",
  label: "Content Interactions",
  growth: "↑ 100% Increase"
}, {
  icon: Users,
  value: "52+",
  label: "New Followers",
  growth: "↑ 100% Increase"
}, {
  icon: FileText,
  value: "10+",
  label: "Content Pieces Created",
  growth: ""
}];
const tags = ["Hybrid Marketing", "Social Media Ads", "Community Engagement", "Lead Generation", "Trust & Verification Campaigns"];
export default function GrowthCIPS() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: salesRef,
    isVisible: salesVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="9518" id="cips-impact" className="bg-muted/30 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-6 lg:px-12">
        <div ref={headerRef} className={`text-center mb-10 transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="font-mono text-[0.75rem] font-medium tracking-[0.2em] uppercase text-primary mb-4">
            MY IMPACT AT
          </p>
          <h2 className="font-default font-bold text-foreground leading-tight tracking-tight text-[clamp(2rem,5vw,3.5rem)]">
            <span className="text-primary">CIPS UK Approved Study Centre of Sri Lanka</span> Hybrid Marketing
          </h2>
        </div>

        {/* Featured Campaign Stat Block */}
        <div ref={salesRef} className={`mb-8 p-8 md:p-12 rounded-2xl border border-primary/30 bg-gradient-to-r from-primary/10 via-secondary/10 to-primary/10 shadow-lg shadow-primary/10 transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] ${salesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="flex-shrink-0 size-14 rounded-xl bg-primary/15 border border-primary/20 flex items-center justify-center">
                <TrendingUp className="size-7 text-primary" strokeWidth={2} />
              </div>
              <div>
                <div className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                  Rs. 2,000,000+
                </div>
                <p className="text-muted-foreground font-medium text-base md:text-lg mt-1">
                  Sales Generated From a Single Campaign
                </p>
              </div>
            </div>
            <div className="flex-shrink-0">
              <span className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 text-primary text-xs md:text-sm font-semibold px-4 py-1.5 uppercase tracking-wider">
                Exceptional ROAS
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {metrics.map((metric, i) => <MetricCard key={metric.label} index={i} {...metric} />)}
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-4">
          {tags.map((tag, i) => <div key={tag} data-index={i} className="flex items-center gap-2 text-foreground/80 font-medium" style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <CheckCircle2 className="size-5 text-primary" />
              <span className="text-sm md:text-base">{tag}</span>
            </div>)}
        </div>
      </div>
    </section>;
}
function MetricCard({
  index,
  icon: Icon,
  value,
  label,
  growth
}: {
  index: number;
  icon: any;
  value: string;
  label: string;
  growth: string;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <div ref={ref} data-index={index} style={{
    transitionDelay: isVisible ? `${index * 100}ms` : "0ms"
  }} className={`group relative bg-card border border-border p-6 md:p-8 flex flex-col justify-center transition-all duration-800 ease-[cubic-bezier(0.16,1,0.3,1)] rounded-2xl shadow-sm hover:shadow-md ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="flex items-start gap-5">
        <div className="flex-shrink-0 size-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon className="size-6 text-primary" strokeWidth={1.5} />
        </div>
        <div className="flex-grow">
          <div className="flex flex-col">
            <span className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
              {value}
            </span>
            <span className="text-muted-foreground font-medium text-sm md:text-base mt-1">
              {label}
            </span>
            {growth && <span className={`text-xs md:text-sm font-semibold mt-2 ${growth.includes("Increase") ? "text-emerald-500" : "text-primary"}`}>
                {growth}
              </span>}
          </div>
        </div>
      </div>
    </div>;
}